import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ariaLabelForCheckboxSelect: {
		id: 'issue.views.field.checkboxSelect.ariaLabel',
		defaultMessage: 'Checkbox Field',
		description: 'ariaLabel for check box field',
	},
});
